module.exports = __webpack_public_path__ + "static/media/test_rover.02da7a16.jpg";